import { mountUiEffects } from "./ui_effects_controller";
import { application } from "./application";
import { registerControllers } from "stimulus-vite-helpers";

// Top-level controllers — auto-registered via filename convention.
// `survey_builder/` is excluded here and registered explicitly below so its
// controllers keep their short identifiers (e.g. `question-card`) instead of
// the path-derived `survey-builder--question-card`.
// Confirmation is registered by critical.js before this main bundle loads.
const topLevelControllers = import.meta.glob(
  ["./**/*_controller.{js,ts}", "!./survey_builder/**", "!./confirmation_controller.ts"],
  { eager: true }
);
registerControllers(application, topLevelControllers);

// Survey-builder feature controllers live in ./survey_builder/ for code
// organization but are registered with their short identifiers so existing
// `data-controller="..."` markup keeps working.
const surveyBuilderControllers = import.meta.glob(
  "./survey_builder/*_controller.{js,ts}",
  { eager: true }
);
Object.entries(surveyBuilderControllers).forEach(([path, mod]) => {
  const filename = path
    .replace(/^\.\/survey_builder\//, "")
    .replace(/_controller\.(js|ts)$/, "");
  const identifier = filename.replace(/_/g, "-");
  const ControllerClass = mod.default ?? mod;
  if (typeof ControllerClass === "function") {
    application.register(identifier, ControllerClass);
  }
});

mountUiEffects();
